import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/content-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function uid() {
    return Math.random().toString(36).substring(2);
}
class ContentLoaderComponent {
    constructor() {
        this.fixedId = uid();
        this.idClip = `${this.fixedId}-diff`;
        this.idGradient = `${this.fixedId}-animated-diff`;
        this.idAria = `${this.fixedId}-aria`;
        this.animate = true;
        this.baseUrl = '';
        this.speed = 1.2;
        this.viewBox = '0 0 0 0';
        this.gradientRatio = 2;
        this.backgroundColor = '#f5f6f7';
        this.backgroundOpacity = 1;
        this.foregroundColor = '#eee';
        this.foregroundOpacity = 1;
        this.rtl = false;
        this.interval = 0.25;
        this.style = {};
        this.animationValues = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.clipPath = `url(${this.baseUrl}#${this.idClip})`;
        this.fillStyle = { fill: `url(${this.baseUrl}#${this.idGradient})` };
        this.style = this.rtl ? Object.assign(Object.assign({}, this.style), { transform: 'scaleX(-1)' }) : this.style;
        this.duration = `${this.speed}s`;
        this.keyTimes = `0; ${this.interval}; 1`;
        this.animationValues = [
            `${-this.gradientRatio}; ${-this.gradientRatio}; 1`,
            `${-this.gradientRatio / 2}; ${-this.gradientRatio / 2}; ${1 + this.gradientRatio / 2}`,
            `0; 0; ${1 + this.gradientRatio}`
        ];
    }
}
ContentLoaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'content-loader',
                template: "<svg [attr.viewBox]=\"viewBox\" [ngStyle]=\"style\">\n  <rect role=\"presentation\" [attr.clip-path]=\"clipPath\" [ngStyle]=\"fillStyle\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" />\n\n  <defs role=\"presentation\">\n    <clipPath [attr.id]=\"idClip\">\n      <ng-content></ng-content>\n    </clipPath>\n\n    <linearGradient [attr.id]=\"idGradient\">\n      <stop offset=\"0%\" [attr.stop-color]=\"backgroundColor\" [attr.stop-opacity]=\"backgroundOpacity\">\n        <ng-container *ngIf=\"animate\">\n          <animate\n            [attr.keyTimes]=\"keyTimes\"\n            attributeName=\"offset\"\n            [attr.values]=\"animationValues[0]\"\n            [attr.dur]=\"duration\"\n            repeatCount=\"indefinite\"\n          />\n        </ng-container>\n      </stop>\n\n      <stop offset=\"50%\" [attr.stop-color]=\"foregroundColor\" [attr.stop-opacity]=\"foregroundOpacity\">\n        <ng-container *ngIf=\"animate\">\n          <animate\n            attributeName=\"offset\"\n            [attr.keyTimes]=\"keyTimes\"\n            [attr.values]=\"animationValues[1]\"\n            [attr.dur]=\"duration\"\n            repeatCount=\"indefinite\"\n          />\n        </ng-container>\n      </stop>\n\n      <stop offset=\"100%\" [attr.stop-color]=\"backgroundColor\" [attr.stop-opacity]=\"backgroundOpacity\">\n        <ng-container *ngIf=\"animate\">\n          <animate\n            attributeName=\"offset\"\n            [attr.keyTimes]=\"keyTimes\"\n            [attr.values]=\"animationValues[2]\"\n            [attr.dur]=\"duration\"\n            repeatCount=\"indefinite\"\n          />\n        </ng-container>\n      </stop>\n    </linearGradient>\n  </defs>\n</svg>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [`
      :host {
        display: block;
      }
    `]
            }] }
];
/** @nocollapse */
ContentLoaderComponent.ctorParameters = () => [];
ContentLoaderComponent.propDecorators = {
    animate: [{ type: Input }],
    baseUrl: [{ type: Input }],
    speed: [{ type: Input }],
    viewBox: [{ type: Input }],
    gradientRatio: [{ type: Input }],
    backgroundColor: [{ type: Input }],
    backgroundOpacity: [{ type: Input }],
    foregroundColor: [{ type: Input }],
    foregroundOpacity: [{ type: Input }],
    rtl: [{ type: Input }],
    interval: [{ type: Input }],
    style: [{ type: Input }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    ContentLoaderComponent.prototype.fixedId;
    /** @type {?} */
    ContentLoaderComponent.prototype.idClip;
    /** @type {?} */
    ContentLoaderComponent.prototype.idGradient;
    /** @type {?} */
    ContentLoaderComponent.prototype.idAria;
    /** @type {?} */
    ContentLoaderComponent.prototype.animate;
    /** @type {?} */
    ContentLoaderComponent.prototype.baseUrl;
    /** @type {?} */
    ContentLoaderComponent.prototype.speed;
    /** @type {?} */
    ContentLoaderComponent.prototype.viewBox;
    /** @type {?} */
    ContentLoaderComponent.prototype.gradientRatio;
    /** @type {?} */
    ContentLoaderComponent.prototype.backgroundColor;
    /** @type {?} */
    ContentLoaderComponent.prototype.backgroundOpacity;
    /** @type {?} */
    ContentLoaderComponent.prototype.foregroundColor;
    /** @type {?} */
    ContentLoaderComponent.prototype.foregroundOpacity;
    /** @type {?} */
    ContentLoaderComponent.prototype.rtl;
    /** @type {?} */
    ContentLoaderComponent.prototype.interval;
    /** @type {?} */
    ContentLoaderComponent.prototype.style;
    /** @type {?} */
    ContentLoaderComponent.prototype.animationValues;
    /** @type {?} */
    ContentLoaderComponent.prototype.clipPath;
    /** @type {?} */
    ContentLoaderComponent.prototype.fillStyle;
    /** @type {?} */
    ContentLoaderComponent.prototype.duration;
    /** @type {?} */
    ContentLoaderComponent.prototype.keyTimes;
    /** @type {?} */
    ContentLoaderComponent.prototype.rtlStyle;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/bullet-list-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BulletListContentLoaderComponent extends ContentLoaderComponent {
}
BulletListContentLoaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'bullet-list-content-loader',
                template: `
    <content-loader viewBox="0 0 245 125">
      <svg:circle cx="10" cy="20" r="8" />
      <svg:rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
      <svg:circle cx="10" cy="50" r="8" />
      <svg:rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
      <svg:circle cx="10" cy="80" r="8" />
      <svg:rect x="25" y="75" rx="5" ry="5" width="220" height="10" />
      <svg:circle cx="10" cy="110" r="8" />
      <svg:rect x="25" y="105" rx="5" ry="5" width="220" height="10" />
    </content-loader>
  `
            }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/facebook-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FacebookContentLoaderComponent extends ContentLoaderComponent {
}
FacebookContentLoaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'facebook-content-loader',
                template: `
    <content-loader viewBox="0 0 476 124">
      <svg:rect x="48" y="8" width="88" height="6" rx="3" />
      <svg:rect x="48" y="26" width="52" height="6" rx="3" />
      <svg:rect x="0" y="56" width="410" height="6" rx="3" />
      <svg:rect x="0" y="72" width="380" height="6" rx="3" />
      <svg:rect x="0" y="88" width="178" height="6" rx="3" />
      <svg:circle cx="20" cy="20" r="20" />
    </content-loader>
  `
            }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/list-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ListContentLoaderComponent extends ContentLoaderComponent {
}
ListContentLoaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'list-content-loader',
                template: `
    <content-loader viewBox="0 0 400 110">
      <svg:rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
      <svg:rect x="20" y="20" rx="3" ry="3" width="220" height="10" />
      <svg:rect x="20" y="40" rx="3" ry="3" width="170" height="10" />
      <svg:rect x="0" y="60" rx="3" ry="3" width="250" height="10" />
      <svg:rect x="20" y="80" rx="3" ry="3" width="200" height="10" />
      <svg:rect x="20" y="100" rx="3" ry="3" width="80" height="10" />
    </content-loader>
  `
            }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/content-loader.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ContentLoaderModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: ContentLoaderModule
        };
    }
}
ContentLoaderModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [
                    ContentLoaderComponent,
                    FacebookContentLoaderComponent,
                    BulletListContentLoaderComponent,
                    ListContentLoaderComponent
                ],
                exports: [
                    ContentLoaderComponent,
                    FacebookContentLoaderComponent,
                    BulletListContentLoaderComponent,
                    ListContentLoaderComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngneat-content-loader.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BulletListContentLoaderComponent, ContentLoaderComponent, ContentLoaderModule, FacebookContentLoaderComponent, ListContentLoaderComponent };
//# sourceMappingURL=ngneat-content-loader.js.map
